import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { WebsiteChromeService } from './website-chrome.service';

export const storyblokFooterResolver = (route: ActivatedRouteSnapshot) => {
  return inject(WebsiteChromeService).footer(route);
};
